import { getDocumentsForm, getValuationReportUploadValue } from '../../../selectors/ugMotorInsurance/documents';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { getCustomerIdValue, getInsuranceQuotationIdValue } from '../../../selectors/ugMotorInsurance/quote';
import { setShowTaggingErrorModal, setTaggingErrorMessage } from '../../../actions/ugMotorInsurance/quote';
import { setDocumentDetailsSubmittedValue } from '../../../actions/ugMotorInsurance/Documents';
import { collectLoginDetails } from '../../../actions/ugMotorInsurance/auth';
import { navigateToCarDetails } from '../../../actions/ugMotorInsurance/routing';
import { setSelectedFormValue } from '../../../actions/ugMotorInsurance/carDetails';

export const uploadDocumentsService = async (store, next, action) => {
    const state = store.getState();

    if (getIsApiPending(state)) {
        return next(action);
    }

    try {
        store.dispatch(apiTransitionPayloadCollection.pending());
        store.dispatch(setShowTaggingErrorModal(false));
        store.dispatch(setTaggingErrorMessage(null));

        const DOCUMENT_KEYS = [
            'nationalId',
            'drivingLicense',
            'logBook',
            'carFrontViewPhoto',
            'carBackViewPhoto',
            'chassisNumberPhoto',
            'carDashboardPhoto',
            'InteriorRadioAndCenterConsolePhoto',
            'EngineOrInsideBonnetPhoto',
            'carLeftViewPhoto',
            'carRightViewPhoto',
        ];

        const inspectionReport = getValuationReportUploadValue(state);
        const documentsToUpload = [...DOCUMENT_KEYS];

        if (inspectionReport?.value?.base64File) {
            documentsToUpload.push('inspectionReport');
        }

        const submissionPromises = documentsToUpload.map(async (docName) => {
            const payload = getPayloadCollection(docName, state);
            await makeSubmission(state, payload);
        });

        const results = await Promise.allSettled(submissionPromises);

        results.forEach((result, index) => {
            if (result.status === 'rejected') {
                console.error(`Error uploading ${documentsToUpload[index]}:`, result.reason);
            }
        });

        store.dispatch(setDocumentDetailsSubmittedValue(true));

        store.dispatch(navigateToCarDetails());
        store.dispatch(setSelectedFormValue('declarations'));
    } catch (error) {
        console.error('Upload failed:', error);
        store.dispatch(setDocumentDetailsSubmittedValue(false));

        const status = error?.response?.status;

        if (status === 401) {
            store.dispatch(collectLoginDetails());
        }

        store.dispatch(setTaggingErrorMessage('Something went wrong. Try again later'));
        store.dispatch(setShowTaggingErrorModal(true));
    } finally {
        store.dispatch(apiTransitionPayloadCollection.initial());
    }

    return next(action);
};

const getPayloadCollection = (docName, state) => {
    const documents = getDocumentsForm(state);

    const customerId = getCustomerIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    const documentMap = {
        nationalId: documents.idUpload?.value?.base64File,
        drivingLicense: documents.licenseUpload?.value?.base64File,
        logBook: documents.logbookUpload?.value?.base64File,
        inspectionReport: documents.valuationReportUpload?.value?.base64File,
        carFrontViewPhoto: documents.carFrontViewPhoto?.value?.base64File,
        carBackViewPhoto: documents.carBackViewPhoto?.value?.base64File,
        chassisNumberPhoto: documents.chassisNumberPhoto?.value?.base64File,
        carDashboardPhoto: documents.carDashboardPhoto?.value?.base64File,
        InteriorRadioAndCenterConsolePhoto: documents.interiorRadioPhoto?.value?.base64File,
        EngineOrInsideBonnetPhoto: documents.enginePhoto?.value?.base64File,
        carRightViewPhoto: documents.carRightViewPhoto?.value?.base64File,
        carLeftViewPhoto: documents.carLeftViewPhoto?.value?.base64File,
    };

    const documentBase64 = documentMap[docName] || null;

    const documentsPayload = {
        customerId: customerId.value,
        quotationId: insuranceQuotationId.value,
        documentType: docName,
        document: documentBase64,
    };

    return {
        ...documentsPayload,
    };
};

export const uploadSingleDocumentService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                let state = store.getState();

                let resp = null;

                const documents = getDocumentsForm(state);

                if (documents.salesAgreement?.value?.base64File) {
                    resp = await makeSubmission(state, singleDocPayloadCollection);

                    if (resp.data) {
                        store.dispatch(apiTransitionPayloadCollection.initial());
                    }
                }

                store.dispatch(apiTransitionPayloadCollection.initial());
            } catch (e) {
                console.error(e);

                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
};

const singleDocPayloadCollection = (documents, state) => {
    const customerId = getCustomerIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    documentBase64 = documents.salesAgreement?.value?.base64File;

    const documentsPayload = {
        customerId: customerId.value,
        quotationId: insuranceQuotationId.value,
        documentType: 'salesAgreementDoc',
        document: documentBase64,
    };

    return {
        ...documentsPayload,
    };
};

const makeSubmission = async (state, payloadCollection) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/upload-document';
        return await axios.post(url, payloadCollection, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
